import { createContext, useContext } from "react";

interface CursorContextProps {
  isHovering?: boolean;
  setIsHovering: (isHovering: boolean) => void;
  isPointer: boolean;
  setIsPointer: (isPointer: boolean) => void;
  hoverText: string;
  setHoverText: (text: string) => void;
  isMorphed: boolean;
  setIsMorphed: (isMorphed: boolean) => void;
  morphStyle: {
    backgroundColor?: string;
    width?: string;
    height?: string;
    clipPath?: string;
    scale?: number;
  };
  setMorphStyle: (style: {
    backgroundColor?: string;
    width?: string;
    height?: string;
    clipPath?: string;
    scale?: number;
  }) => void;
  shapePaths: string[];
  shapeColors: string[];
  setShape: (paths: string[], colors: string[]) => void;
}

export const CursorContext = createContext<CursorContextProps | undefined>(
  undefined,
);

export const useCursor = (): CursorContextProps => {
  const context = useContext(CursorContext);
  if (!context) {
    throw new Error("useCursor must be used within a CursorProvider");
  }
  return context;
};
